var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M12 0H6v2H0v4h36V2h-6V0h-6v2H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    fillRule: "evenodd",
    d: "M36 8H0v28h36zM4 12v4h4v-4zm0 8v4h4v-4zm4 8v4H4v-4zm8-16h-4v4h4zm-4 8h4v4h-4zm4 8h-4v4h4zm4-16h4v4h-4zm4 8h-4v4h4zm-4 8h4v4h-4zm8-16v4h4v-4zm4 8v4h-4v-4zm-4 8v4h4v-4z",
    clipRule: "evenodd"
  })));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDBINlYySDBWNkgzNlYySDMwVjBIMjRWMkgxMlYwWiIgZmlsbD0iI0MyQzJDMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM2IDhIMFYzNkgzNlY4Wk00IDEyVjE2SDhWMTJINFpNNCAyMFYyNEg4VjIwSDRaTTggMjhWMzJINFYyOEg4Wk0xNiAxMkgxMlYxNkgxNlYxMlpNMTIgMjBIMTZWMjRIMTJWMjBaTTE2IDI4SDEyVjMySDE2VjI4Wk0yMCAxMkgyNFYxNkgyMFYxMlpNMjQgMjBIMjBWMjRIMjRWMjBaTTIwIDI4SDI0VjMySDIwVjI4Wk0yOCAxMlYxNkgzMlYxMkgyOFpNMzIgMjBWMjRIMjhWMjBIMzJaTTI4IDI4VjMySDMyVjI4SDI4WiIgZmlsbD0iI0MyQzJDMiIvPgo8L3N2Zz4K";